var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"avatar",staticClass:"avatar-icon",class:{'avatar-list': _vm.isAbsolute},style:(_vm.iconStyles)},[_vm._v("\n  "+_vm._s(_vm.avatarInitials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }